export class EoQueryFiltersModel {
  eoNumber: string;
  revisionsCompliedWith: string[];
  partsAccomplished: number;
  keywords: string[] | null;
  malfunctionCodes: string[] | null;
  ATA: string[] | null;
}
